import { render, staticRenderFns } from "./VendorHome.vue?vue&type=template&id=7bd65784&scoped=true&"
import script from "./VendorHome.vue?vue&type=script&lang=js&"
export * from "./VendorHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd65784",
  null
  
)

export default component.exports